// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2MVvN","title":"ClientInsurance_title__EczY7","itemText":"ClientInsurance_itemText__3rgeG"};